import type { CountryCode, Locale } from "@commerce-frontend/i18n/types";

export const storeKeys = ["NL", "DE", "BE", "LU", "AT", "FR", "ES", "PT"] as const;
export type StoreKey = (typeof storeKeys)[number];
export type RepositoryKey = "EXAMPLE";
export type Currency = "EUR";
export type StoreTheme = "example";
export type CheckoutConfig = {
	maxLineLength: number;
};
export const classNames = ["example"] as const;
export type ClassName = (typeof classNames)[number];

export type PaymentMethod = "card" | "paypal";

export type StoreMetadata = {
	siteName: string;
	tagline: {
		[key in Locale]?: string;
	};
	keywords: string[];
	productionUrl: string;
};

export type SiteConfig = {
	url: string;
	defaultLocale: Locale;
	locales: Locale[];
};

export type StoreConfig = {
	defaultLocale: Locale;
	locales: Locale[];
	storeKey: StoreKey;
	creditCardBrands: string[];
	country: CountryCode;
	currency: Currency;
	timezone: string;
	metadata: StoreMetadata;
	etrustedEnabled: boolean;
};

export type StoreConfigOptions = Partial<StoreConfig>;

export const isStoreKey = (storeKey: string): storeKey is StoreKey =>
	storeKeys.includes(storeKey as StoreKey);
